import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api';
import Layout from '../../components/Layout';

const ProfessorQuizPreview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [quiz, setQuiz] = useState<any>(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState<Record<string, string>>({});
  const [score, setScore] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuiz = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/quizzes/${id}`);
        setQuiz(response.data.data); // Notez l'accès à response.data.data
        setLoading(false);
      } catch (error) {
        console.error('Error fetching quiz:', error);
        setLoading(false);
      }
    };
    fetchQuiz();
  }, [id]);

  const handleAnswer = (questionId: string, selectedOption: string) => {
    setUserAnswers({ ...userAnswers, [questionId]: selectedOption });
  };

  const handleSubmit = () => {
    if (!quiz) return;

    let correctAnswers = 0;
    quiz.questions.forEach((question: any) => {
      if (userAnswers[question._id] === question.correctAnswer) {
        correctAnswers++;
      }
    });
    setScore((correctAnswers / quiz.questions.length) * 100);
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-600"></div>
        </div>
      </Layout>
    );
  }

  if (!quiz) {
    return (
      <Layout>
        <div className="text-center py-12">
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Quiz non trouvé
          </h3>
          <button
            onClick={() => navigate('/Professor/quizzes')}
            className="px-4 py-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700 transition-colors mt-4"
          >
            Retour à la liste des quiz
          </button>
        </div>
      </Layout>
    );
  }

  const currentQuestion = quiz.questions[currentQuestionIndex];

  return (
    <Layout>
      <div className="container mx-auto p-4">
        <h1 className="text-2xl font-bold mb-4">{quiz.title}</h1>
        
        {score === null ? (
          <div>
            <p className="mb-2">
              Question {currentQuestionIndex + 1} sur {quiz.questions.length}
            </p>
            <p className="text-lg font-semibold mb-4">{currentQuestion.questionText}</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {currentQuestion.options.map((option: string, index: number) => (
                <button
                  key={index}
                  onClick={() => handleAnswer(currentQuestion._id, option)}
                  className={`p-4 rounded-lg border-2 ${
                    userAnswers[currentQuestion._id] === option 
                      ? 'border-brand-500 bg-brand-50' 
                      : 'border-gray-300 hover:bg-gray-50'
                  } transition-colors`}
                >
                  {option}
                </button>
              ))}
            </div>
            
            <div className="mt-6 flex justify-between">
              {currentQuestionIndex > 0 && (
                <button 
                  onClick={() => setCurrentQuestionIndex(currentQuestionIndex - 1)} 
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  Précédent
                </button>
              )}
              
              {currentQuestionIndex < quiz.questions.length - 1 ? (
                <button 
                  onClick={() => setCurrentQuestionIndex(currentQuestionIndex + 1)} 
                  className="px-4 py-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700 transition-colors ml-auto"
                >
                  Suivant
                </button>
              ) : (
                <button 
                  onClick={handleSubmit} 
                  className="px-4 py-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700 transition-colors ml-auto"
                >
                  Soumettre
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className="text-center">
            <h2 className="text-xl font-bold mb-4">Résultats du Quiz</h2>
            <div className="bg-white rounded-lg shadow-sm p-6 max-w-md mx-auto">
              <div className={`text-4xl font-bold mb-2 ${
                score >= 70 ? 'text-brand-600' : 'text-brand-600'
              }`}>
                {score.toFixed(2)}%
              </div>
              <p className="text-gray-600 mb-4">
                {score >= 70 ? 'Félicitations !' : 'Essayez encore !'}
              </p>
              <button 
                onClick={() => navigate('/Professor/quizzes')} 
                className="px-4 py-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700 transition-colors"
              >
                Retour à la liste des quiz
              </button>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ProfessorQuizPreview;